import {
  AxiosDeleteRequestOptions,
  AxiosGetRequestOptions,
  AxiosPostRequestOptions,
  AxiosPutRequestOptions,
} from '@/package';
import type { UserGroupApi } from '@/type';
import { apiOf } from '@/util';

export const create = apiOf<
  UserGroupApi.Create.Request,
  UserGroupApi.Create.Response
>(new AxiosPostRequestOptions({ url: '/v1/miri/usergroup' }));

export const getDetail = apiOf<
  UserGroupApi.GetDetail.Request,
  UserGroupApi.GetDetail.Response
>(new AxiosGetRequestOptions({ url: '/v1/miri/usergroup/:id' }));

export const getList = apiOf<
  UserGroupApi.GetList.Request,
  UserGroupApi.GetList.Response
>(new AxiosGetRequestOptions({ url: '/v1/miri/usergroup' }));

export const getCount = apiOf<
  UserGroupApi.GetCount.Request,
  UserGroupApi.GetCount.Response
>(new AxiosGetRequestOptions({ url: '/v1/miri/usergroup/count' }));

export const update = apiOf<
  UserGroupApi.Update.Request,
  UserGroupApi.Update.Response
>(new AxiosPutRequestOptions({ url: '/v1/miri/usergroup/:id' }));

export const mapUser = apiOf<
  UserGroupApi.MapUser.Request,
  UserGroupApi.MapUser.Response
>(new AxiosPostRequestOptions({ url: '/v1/miri/usergroup/:pGroupID/user' }));

export const unMapUser = apiOf<
  UserGroupApi.UnMapUser.Request,
  UserGroupApi.UnMapUser.Response
>(new AxiosDeleteRequestOptions({ url: '/v1/miri/usergroup/:pGroupID/user' }));

export const remove = apiOf<
  UserGroupApi.Remove.Request,
  UserGroupApi.Remove.Response
>(new AxiosDeleteRequestOptions({ url: '/v1/miri/usergroup/:id' }));
